import { Stack } from '@mui/material';
import { ExtendedTypography } from '@issuemanager/apps/client/components';
import { useAtlasSemanticThemeTokens } from '@issuemanager/apps/client/theme';
import { Indicator, IndicatorProps } from './indicator';

type DataDisplayProps = {
  title: string;
  data: Omit<IndicatorProps, 'testId'>[];
};
export function DataDisplay({ title, data }: DataDisplayProps) {
  const semantic = useAtlasSemanticThemeTokens();

  return (
    <Stack>
      <ExtendedTypography
        variant='label'
        // NOTE: fontWeight is not being applied by variant="label". That's why is overwritten here
        fontWeight={600}
        color={semantic.color.text.body.value}
      >
        {title}
      </ExtendedTypography>
      <Stack alignContent='flex-start' spacing={2} direction='row' mt={1}>
        {data.map((item) => (
          <Indicator
            {...item}
            testId={item.title.toLowerCase().replace(/ /g, '-')}
          />
        ))}
      </Stack>
    </Stack>
  );
}
